import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-orientation-modal',
  templateUrl: './orientation-modal.component.html',
  styleUrls: ['./orientation-modal.component.scss']
})
export class OrientationModalComponent implements OnInit, AfterViewInit {
  @Input() selectedImage;
  @Input() editHotspots;
  @ViewChild('rendererContainerOrientation') rendererContainerOrientation: ElementRef;
  @Output() setInitialViewEmit = new EventEmitter();
  @ViewChild('cssRendererContainerOrientation') cssRendererContainerOrientation: ElementRef;

  loading = true;

  // Three js basic controls scene camera
  animateId: any;
  controls = null;
  rendererOrientation = null;
  scene = null;
  camera = null;
  ambientLight = null;
  pointLight = null;
  geometry = null;
  material = null;
  raycaster = new THREE.Raycaster();

  // Canvas, mouse config
  manualControl = false;
  mouse = new THREE.Vector2(0, 0);

  // SPHERE
  sphereMesh = null;

  // Canvas, mouse config
  canvasConfig = {
    manualControl: false,
    CANVAS_HEIGHT: 850,
    CANVAS_WIDTH: 1200,
    CANVAS_CENTER_X: 0,
    CANVAS_CENTER_Y: 0,
  };

  currentMesh = null;

  cssSceneEdit = null;
  cssRendererEdit = null;

  mousePosition = new THREE.Vector2();

  orientationMesh = [];

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.init();
    }, 1000);


  }

  init() {
    this.initScene();
    this.initCameraAndLight();
    this.initControls();
    this.createCubes();
    this.animate();
  }

  initScene() {
    this.rendererOrientation = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });
    this.rendererOrientation.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    this.rendererContainerOrientation.nativeElement.appendChild( this.rendererOrientation.domElement );
    this.scene = new THREE.Scene();

    // Css renderer
    this.cssSceneEdit = new THREE.Scene();
    this.cssRendererEdit = new THREE.CSS2DRenderer();

    this.canvasConfig.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererContainerOrientation.nativeElement).width));
    this.canvasConfig.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererContainerOrientation.nativeElement).height));
    this.canvasConfig.CANVAS_CENTER_X = this.canvasConfig.CANVAS_WIDTH / 2;
    this.canvasConfig.CANVAS_CENTER_Y = this.canvasConfig.CANVAS_HEIGHT / 2;

    // Css renderer
    this.cssRendererEdit.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    this.cssRendererEdit.domElement.style.position = 'absolute';
    this.cssRendererEdit.domElement.style.top = 0;
    this.cssRendererContainerOrientation.nativeElement.appendChild(this.cssRendererEdit.domElement);

  }

  initCameraAndLight() {
    this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1000 );
    this.camera.position.z = 0.025;
    this.ambientLight = new THREE.AmbientLight( 0xcccccc, 0.4 );
    this.scene.add( this.ambientLight );
    this.pointLight = new THREE.PointLight( 0xffffff, 0.8 );
    this.camera.add( this.pointLight );
    this.scene.add( this.camera );
  }

  initControls() {

    this.controls = new THREE.OrbitControls( this.camera, this.cssRendererEdit.domElement );

    this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    this.controls.dampingFactor = 0.1;
    this.controls.rotateSpeed = 0.04;
    this.controls.enableZoom = false;
    this.controls.maxDistance = 20;

    // this.controls.enableZoom = false;
    // this.controls.maxDistance = 20;

    // this.controls = new THREE.OrbitControls( this.camera, this.rendererOrientation.domElement );
    // this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    // this.controls.dampingFactor = 0.05;
    // this.controls.rotateSpeed = 0.04;
    // this.controls.screenSpacePanning = false;
    // this.controls.enableZoom = false;
    // this.controls.maxDistance = 20;

    // this.controls = new THREE.OrbitControls( this.camera, this.rendererOrientation.domElement );
    // this.controls.target.set(0, 0, 0);
    // this.controls.enableDamping = true;
    // this.controls.dampingFactor = 0.02;
    // this.controls.rotateSpeed = 0.02;
  }

  createCubes() {
    const materialArray = this.createCubeTextureMaterial(this.selectedImage, 1);
    const skyBox = new THREE.Mesh( new THREE.BoxGeometry( 200, 200, 200 ), materialArray );
    skyBox.name = this.selectedImage.uuid;
    // skyBox.position.set(0, 0, 0);
    this.currentMesh = skyBox;
    this.scene.add(skyBox);

    if (this.editHotspots && this.editHotspots.media_link.uuid === this.selectedImage.uuid && this.editHotspots.orientation && this.editHotspots.orientation.posX) {
      this.initOrientationSprite();
    }

  }

  initOrientationSprite() {
    let content = '';
    content += '<div class="starthere-block">';
    content += '<div class="inner-block">';
    content += '<div class="icon-block">';
    content += '<i class="far fa-compass text-white" tooltip="vr" placement="top"></i>';
    content += '</div>';
    content += '<div class="text-block">';
    content += '<p class="m-b-0 text-white">Starts here</p>';
    content += '</div>';
    content += '</div>';
    content += '</div>';
    const element = document.createElement('div');
    element.innerHTML = content;
    const sprite = new THREE.CSS2DObject( element );
    sprite.position.set(this.editHotspots.orientation.posX, this.editHotspots.orientation.posY, this.editHotspots.orientation.posZ);
    sprite.name = 'orientation';
    sprite.hotspot_type = 'link';
    this.orientationMesh.push(sprite);
    this.currentMesh.add( sprite );
  }


  createCubeTextureMaterial(mediaData, opacityValue) {
    const materialArray = [];

    const loader = new THREE.TextureLoader();
    const textureRight = loader.load( mediaData.cubemap[0] ); // Right
    const textureLeft = loader.load( mediaData.cubemap[5] ); // left
    const textureTop = loader.load( mediaData.cubemap[1] ); // top
    const textureBottom = loader.load( mediaData.cubemap[2] ); // bottom
    const textureBack = loader.load( mediaData.cubemap[4] ); // back
    const textureFront = loader.load( mediaData.cubemap[3] ); // front
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureRight, side: THREE.DoubleSide, transparent: true, opacity: opacityValue, needsUpdate: true }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureLeft, side: THREE.DoubleSide, transparent: true, opacity: opacityValue, needsUpdate: true  }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureTop, side: THREE.DoubleSide, transparent: true, opacity: opacityValue, needsUpdate: true  }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureBottom, side: THREE.DoubleSide, transparent: true, opacity: opacityValue, needsUpdate: true  }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureBack, side: THREE.DoubleSide, transparent: true, opacity: opacityValue, needsUpdate: true  }));
    materialArray.push(new THREE.MeshBasicMaterial( { map: textureFront, side: THREE.DoubleSide, transparent: true, opacity: opacityValue, needsUpdate: true  }));
    return materialArray;
  }

  render() {
    if (this.rendererOrientation) {
        this.rendererOrientation.render(this.scene, this.camera);
    }
    if (this.cssRendererEdit) {
      this.cssRendererEdit.render( this.scene, this.camera );
    }

  }

  animate() {
    this.animateId = requestAnimationFrame(this.animate.bind(this));
    if (this.camera) {
      this.updateMetaTagsRotationOnMouseMove();
      this.controls.update();
      this.render();
    }
  }

  resizeHandler(event) {
    if (this.rendererOrientation) {
      this.canvasConfig.CANVAS_WIDTH = Math.round(parseFloat(getComputedStyle(this.rendererContainerOrientation.nativeElement).width));
      this.canvasConfig.CANVAS_HEIGHT = Math.round(parseFloat(getComputedStyle(this.rendererContainerOrientation.nativeElement).height));
      this.camera.aspect = this.canvasConfig.CANVAS_WIDTH / this.canvasConfig.CANVAS_HEIGHT;
      this.camera.updateProjectionMatrix();
      this.rendererOrientation.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
      // Css renderer
      this.cssRendererEdit.setSize( this.canvasConfig.CANVAS_WIDTH, this.canvasConfig.CANVAS_HEIGHT );
    }
  }

  removeComponentProperties() {
    cancelAnimationFrame(this.animateId); // Stop the animation
    this.rendererOrientation.domElement.addEventListener('dblclick', null, false); // remove listener to render
    this.scene.remove(this.sphereMesh);
    this.sphereMesh.geometry.dispose();
    this.sphereMesh.material.dispose();
    this.sphereMesh = undefined;
    this.scene = null;
    this.camera = null;
    this.controls = null;
    this.empty(this.rendererContainerOrientation.nativeElement);
    this.removeData();
  }

  empty(elem) {
      while (elem.lastChild) {
        elem.removeChild(elem.lastChild);
      }
  }

  removeData() {
    this.sphereMesh = null;
  }

  closeModal() {
    this.setInitialViewEmit.emit(undefined);
  }

  setInitialView() {
    const vector = new THREE.Vector3(); // create once and reuse it!
    const position = this.camera.getWorldDirection( vector );

    const rayCaster = new THREE.Raycaster();
    rayCaster.setFromCamera(this.mouse, this.camera);
    const intersects = rayCaster.intersectObjects( [this.currentMesh], true );
    if ( intersects.length > 0 ) {
      this.render();
      const orientationPosition = rayCaster.ray.at(50);
      const orientation = {
          x: this.camera.position.x,
          y: this.camera.position.y,
          z: this.camera.position.z,
          posX: orientationPosition.x,
          posY: orientationPosition.y,
          posZ: orientationPosition.z,
      };
      this.setInitialViewEmit.emit(orientation);
    }

  }

  onMouseMove( event ) {
    if (this.camera && (event.target && event.target.parentElement && event.target.parentElement.id === 'cssEdit') ||
    (event.target && event.target.parentNode && event.target.parentNode.parentElement && event.target.parentNode.parentElement.id === 'cssEdit')
    ) {
        this.canvasConfig.manualControl = true;
        const canvasBounds = this.rendererOrientation.getContext().canvas.getBoundingClientRect();
        this.mouse.x = ( ( event.clientX - canvasBounds.left ) / ( canvasBounds.right - canvasBounds.left ) ) * 2 - 1;
        this.mouse.y = - ( ( event.clientY - canvasBounds.top ) / ( canvasBounds.bottom - canvasBounds.top) ) * 2 + 1;
    }

  }

  updateMetaTagsRotationOnMouseMove() {
    let i;
    for (i = 0; i < this.orientationMesh.length; i++) {
      const ringMesh = this.orientationMesh[i];
      ringMesh.setRotationFromQuaternion(this.camera.quaternion);
      ringMesh.updateMatrix();
    }
  }

}
